
export default {
  name: 'CreateExamination',
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '问卷网已帮助681万用户 收集超过4.1亿份数据',
    },
    url: {
      type: String,
      default: '/list/',
    },
    btnText: {
      type: String,
      default: '进入工作台',
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    },
    isMobile() {
      return this.$store.state.isMobile
    },
  },
}
